<template>
  <span class="text-caption primary--text font-weight-bold">{{ $t("poll.msgResponded") }}</span>
</template>

<script>
export default {
  name: "RespondedMsg",
};
</script>

